import './sidebar.min';
import {extend} from 'lodash';
export function sidebarInit(options) {
    // 侧边栏配置
    var defaultOptions = {
        style: {
            width: '85%',
            headBgColor: 'rgba(255,255,255,1)',
            headTextSize: '.15rem',
            headHeight: '2.5rem',
            itemTitleHeight: '1.25rem',
            itemHeight: '2.5rem',
            itemTextSize: '0.9375rem'
        }
    };
    defaultOptions = extend(defaultOptions, options, true);
    // new三个sidebar，分别给车型、省份、城市,并设置同样的样式属性,其中省份点击后不需要隐藏
    window.provinceSidebar = new Sidebar(extend({activeHide: false}, defaultOptions, true));
    window.citySidebar = new Sidebar(defaultOptions);

    provinceSidebar.on('change', function (a) {
        vm.provinceIdTemp = a.id;
        vm.showCitySidebar();
    })
    citySidebar.on('change', function (a) {
        vm.cityId = a.id;
        vm.cityName = a.text;
        // 选中城市的时候，把当前的省份赋值给真正的选中省份
        vm.provinceId = vm.provinceIdTemp;
        vm.$eventBus.$emit("cityData", {cityId: a.id, cityName: a.text, provinceId:vm.provinceIdTemp});
        provinceSidebar.hide();
    })
    // 当城市隐藏却没有城市被选中的时候，证明当前的操作是“返回”，需要回退省份选择
    citySidebar.on('hide', function (a) {
        if (!citySidebar.getActive().id) {
            provinceSidebar.active(vm.provinceId);
        }
    })
}